module.exports = __webpack_public_path__ + "img/logorutify-dark.e8e4b1bb.png";